// extracted by mini-css-extract-plugin
module.exports = {"logo":"SignIn_logo__2Tlje","signInWrapper":"SignIn_signInWrapper__38xzM","links":"SignIn_links__YnfA3"};